module.exports = __webpack_public_path__ + "img/uday.787c1033.jpeg";